// eslint-disable-next-line import/extensions
import { validateEmailFormat } from '../../../scripts/helpers/helpers.js';

const Newsletter = () => {
	/**
	 * The wrapper div. Should be on the `page-newsletter.twig` template.
	 * @type {HTMLDivElement | null}
	 */
	const newsLetterWrapper = document.querySelector('.newsletter');

	/** @type {HTMLInputElement | null} */
	const emailField = document.querySelector('.newsletter__wrapper .email');

	/** @type {HTMLButtonElement | null} */
	const submitBtn = document.querySelector('.newsletter__wrapper button[type="submit"]');

	// If any of the form elements are missing, do nothing.
	if (!(newsLetterWrapper && emailField && submitBtn)) {
		return;
	}

	// Update the email field if it's already set in the local storage to remember the user's input.
	const updateEmailField = () => {
		// check if local storage has email.
		if (localStorage.getItem('newsletterEmail') && localStorage.getItem('newsletterEmail') !== '') {
			// eslint-disable-next-line camelcase
			emailField.value = localStorage.getItem('newsletterEmail');
		}
	};

	/**
	 * Validate the entered email address on keyup.
	 * @param {KeyboardEvent} e
	 */
	const validateEmailAddress = (e) => {
		// check if div.newsletter__invalid-message has class active.
		if (document.querySelector('.newsletter__invalid-message').classList.contains('active')) {
			// eslint-disable-next-line camelcase
			if (validateEmailFormat(e.target.value)) {
				document.querySelector('.newsletter__invalid-message').classList.remove('active');
			}
		}
	};

	/**
	 * Save email in local storage, to be restored on page refresh.
	 * @param {Event} e
	 */
	const saveEmail = (e) => {
		// eslint-disable-next-line camelcase
		localStorage.setItem('newsletterEmail', e.target.value);
	};

	updateEmailField();

	submitBtn.addEventListener('click', (e) => {
		e.preventDefault();

		// Define the form to be used later.
		const form = document.querySelector('.newsletter__wrapper form');

		// validate Email.
		// eslint-disable-next-line camelcase
		if (!validateEmailFormat(emailField.value)) {
			form.querySelector('.newsletter__invalid-message').classList.add('active');
			// prevent form submission and exit.
			return;
		}

		const formDataEntries = new FormData(form).entries();
		const formData = Object.fromEntries(formDataEntries);
		const apiURL = '/wp-json/newsletter/v1/form';

		const fetchOptions = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formData),
		};

		// send email to server using fetch post.
		fetch(apiURL, fetchOptions)
			.then((response) => {
				if (response.status === 200) {
					newsLetterWrapper.classList.add('newsletter__success');

					/* Use handleSuccessMessageAnalytics if defined in `adobe_analytics.js` */
					if (typeof handleSuccessMessageAnalytics === 'function') {
						// Remove the last click interaction
						delete window.codexData.interaction;

						// eslint-disable-next-line no-undef
						handleSuccessMessageAnalytics();

						// Clear the signup flow on the next click or scroll
						const clearSignupFlow = () => {
							document.removeEventListener('click', clearSignupFlow, true);
							window.removeEventListener('scroll', clearSignupFlow);

							// eslint-disable-next-line no-unused-vars
							const { flow, ...codexData } = window.codexData;
							window.codexData = { ...codexData, events: { view: false } };
						};

						document.addEventListener('click', clearSignupFlow, true);
						window.addEventListener('scroll', clearSignupFlow);
					}
				}
			}).catch((error) => {
				console.warn(error);
			});
	});

	emailField.addEventListener('keyup', validateEmailAddress);
	emailField.addEventListener('change', validateEmailAddress);
	emailField.addEventListener('change', saveEmail);
};

export default Newsletter;
